import React, { useEffect, useRef } from "react";

function TickerMarquee({
  text = "",
  speed = 52,
  outerStyle,
  trackStyle,
  textStyle,
}) {
  const trackRef = useRef(null);
  const segmentRef = useRef(null);
  const widthRef = useRef(0);

  useEffect(() => {
    const updateWidth = () => {
      widthRef.current = segmentRef.current?.offsetWidth || 0;
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    let rafId = 0;
    let lastTime = 0;
    let offset = 0;

    const step = (time) => {
      if (!lastTime) lastTime = time;
      const delta = (time - lastTime) / 1000;
      lastTime = time;
      const segmentWidth = widthRef.current;
      if (segmentWidth > 0 && trackRef.current) {
        offset += speed * delta;
        if (offset >= segmentWidth) offset -= segmentWidth;
        trackRef.current.style.transform = `translate3d(-${offset}px,0,0)`;
      }
      rafId = window.requestAnimationFrame(step);
    };

    rafId = window.requestAnimationFrame(step);

    return () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener("resize", updateWidth);
    };
  }, [speed, text]);

  if (!String(text).trim()) return null;

  return (
    <div style={outerStyle}>
      <div ref={trackRef} style={trackStyle}>
        <span ref={segmentRef} style={textStyle}>{text}</span>
        <span style={textStyle}>{text}</span>
      </div>
    </div>
  );
}

export default TickerMarquee;
